import { render, staticRenderFns } from "./DisplayDatetime.vue?vue&type=template&id=83c1ca9c&"
import script from "./DisplayDatetime.vue?vue&type=script&lang=js&"
export * from "./DisplayDatetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports